(function () {
    'use strict';

    angular
        .module('procedureControllers')
        .controller('ProcedureSectionBlockViewController', Controller);

    Controller.$inject = ['$scope', '$location', '$state', 'notificationService', 'attachmentService', 'languageService', '$http'];

    function Controller($scope, $location, $state, notificationService, attachmentService, languageService, $http) {
        /** @property sectionBlock comes from parent scope */

        $scope.languageService = languageService;

        $scope.sectionCtxtCtrl = {

            // section block url
            sectionUrl: $location.absUrl() + '#' + $scope.sectionBlock.Anchor,

            // References
            lookupReferences: null,

            // Tooltip settings
            ttEnabled: true,
            ttDelay: 300
        };

        $scope.clipboardCopySectionSuccess = function (event) {
            notificationService.notify($scope.sectionBlock.Anchor  + " URL copied to clipboard");
        };

        $scope.clipboardCopySectionError = function (event) {
            notificationService.warn("Failed to copy "+ $scope.sectionBlock.Anchor + " URL to clipboard");
        };

        // Get Attachment URL
        $scope.getAttachmentUrl = function (attachment) {
            return attachmentService.getDownloadUrl(attachment.AttachmentExternalID);
        };

      // Download Attachment
      $scope.downloadAttachment = function (existingAttachment) {
        $http({
          method: 'GET',
          url: $scope.getAttachmentUrl(existingAttachment),
          responseType: 'blob'
        }).then(function (response) {
          const file = getFileFromBlob(response.data, existingAttachment.FileName, response.data.type);
          downloadFile(file);
        });
      }

      function getFileFromBlob(blobPart, fileName, contentType) {
        if (!fileName || !contentType) {
          return;
        }

        const blob = new Blob([blobPart], { type: contentType });
        const file = new File([blob], fileName);

        return file;
      }

      function downloadFile(file) {
        const fileName = file.name;

        // For IE
        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          window.navigator.msSaveOrOpenBlob(file, fileName);
        } else {
          const link = document.createElement('a');

          link.style.display = 'none';
          link.href = window.URL.createObjectURL(file);
          link.download = fileName;

          document.body.appendChild(link);
          link.click();

          // For Firefox, we need to postpone the removal of the link
          setTimeout(() => {
            window.URL.revokeObjectURL(link.href);
            link.remove();
          }, 0)
        }
      }

        // Get Attachment URL
        $scope.getControlUrl = function (control) {
            return $state.href('control', {ControlID: control.ControlID});
        };

        var sectionBlockLookupsByAttributeID = {};

        _.forOwn($scope.sectionBlockLookups, function (lookupAttribute) {
            sectionBlockLookupsByAttributeID[lookupAttribute.LookupAttributeID] = lookupAttribute;
        });

        initLookupAttributeValueReferences();
        initInlineReferences();

        function initLookupAttributeValueReferences() {
            $scope.sectionCtxtCtrl.lookupReferences = {
                Committee: [],
                CorporateRole: [],
                GlossaryTerm: [],
                ProcessOutput: []
            };

            // Group lookup attribute values by Lookup Attribute Code and assign to the context object
            var groupedAttrValues =
                    _.groupBy($scope.sectionBlock.LookupReferences, 'LookupAttributeID');

            _.forOwn(groupedAttrValues, function (lookupAttributeValues, lookupAttrId) {
                var lookupAttribute = sectionBlockLookupsByAttributeID[lookupAttrId];

                $scope.sectionCtxtCtrl.lookupReferences[lookupAttribute.Code] = lookupAttributeValues;
            });
        }

        function initInlineReferences() {
            // For each supported inline ref type, mount data in the form of: inlineReferencess[ItemType/LookupCode][ID] = {reference}
            $scope.sectionBlock.inlineReferences = {
                BusinessUnit: {},
                Committee: {},
                CorporateRole: {},
                GlossaryTerm: {},
                IAMSystem: {},
                Section: {},
                Procedure: {},
            };

            // Business Unit
            _.each($scope.sectionBlock.BusinessUnitReferences, function (businessUnitRef) {
                $scope.sectionBlock.inlineReferences.BusinessUnit[businessUnitRef.BusinessUnitID] = businessUnitRef;
            });

            // Committee
            _.each($scope.sectionBlock.CommitteeReferences, function (committeeRef) {
                $scope.sectionBlock.inlineReferences.Committee[committeeRef.CommitteeID] = committeeRef;
            });

            // Corporate Role
            _.each($scope.sectionBlock.CorporateRoleReferences, function (corporateRoleRef) {
                $scope.sectionBlock.inlineReferences.CorporateRole[corporateRoleRef.CorporateRoleID] = corporateRoleRef;
            });

            // Glossary Term
            _.each($scope.sectionCtxtCtrl.lookupReferences.GlossaryTerm, function (glossaryTermRef) {
                $scope.sectionBlock.inlineReferences.GlossaryTerm[glossaryTermRef.LookupAttributeValueID] = glossaryTermRef;
            });

            // IAM System
            _.each($scope.sectionBlock.IAMSystemReferences, function (iamSystemRef) {
                $scope.sectionBlock.inlineReferences.IAMSystem[iamSystemRef.IAMSystemID] = iamSystemRef;
            });

            // Sections
            _.each($scope.sectionBlock.SectionBlocks, function (sectionBlock) {
                $scope.sectionBlock.inlineReferences.Section[sectionBlock.SectionBlockMasterID] = sectionBlock;
            });

            // Procedures
            _.each($scope.sectionBlock.ProcedureReferences, function (procedure) {
                $scope.sectionBlock.inlineReferences.Procedure[procedure.ProcedureID] = procedure;
            });
        }

        // Update the grouped lookup attribute references when model changes
        $scope.$watchCollection('sectionBlock.LookupReferences', function (newValue) {
            if (newValue) {
                initLookupAttributeValueReferences();
            }
        })
    }
})();
